import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace GeneralRally {
  export const form: IEventRegisterRow[] = [
    {
      // Allows a dog to enter the same class multiple times (e.g. run Novice
      // several times at different available timeslots) via the "+" button.
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_novice,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_novice, id: Constants.dog_class_element_level.general_rally_novice }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_intermediate,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_intermediate, id: Constants.dog_class_element_level.general_rally_intermediate }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_advanced,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_advanced, id: Constants.dog_class_element_level.general_rally_advanced }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_excellent,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_excellent, id: Constants.dog_class_element_level.general_rally_excellent }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_master,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_master, id: Constants.dog_class_element_level.general_rally_master }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.general_rally_choice,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.general_rally_choice, id: Constants.dog_class_element_level.general_rally_choice }
        ]
      }]
    }
  ];
}
